import { FormikProps } from "formik";
import { useContext } from "react";
import {
  BlankMediaPeriodInfo,
  BlankMediaTypeCommonDataViewModel,
  EquipmentItemViewModel,
  ItemViewModel,
  SubmitBlankMediaProfessionalUserApplication,
} from "../../../../../generated/data-contracts";
import { IUrlParamsBlankMedia } from "../../../../../models";
import { NotPortalReportMessage } from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context";
import { CommonData } from "../forms/CommonDataForm";
import { NoDealCheckbox } from "../forms/NoDealCheckbox";
import { ApplicationSections } from "./sections/ApplicationSections";

interface IBlankMediaTypeProfessionalUserApplicationFormProps {
  applicationData: BlankMediaTypeCommonDataViewModel | undefined;
  bag: FormikProps<SubmitBlankMediaProfessionalUserApplication>;
  periodInfo: BlankMediaPeriodInfo | undefined;
  equipments: EquipmentItemViewModel[] | undefined;
  importersAndManufacturers: ItemViewModel[] | undefined;
  sectionsVisible: boolean | undefined;
  noDealAccepted: boolean;
  hasNoPortalReport: boolean | undefined;
  setNoDealAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  urlParams: IUrlParamsBlankMedia;
  disabled: boolean | undefined;
  loading: boolean | undefined;
  onPeriodChange?: (dateFrom?: Date, dateTo?: Date) => void;
}

export function BlankMediaTypeProfessionalUserApplicationForm(
  props: Readonly<IBlankMediaTypeProfessionalUserApplicationFormProps>,
) {
  const {
    applicationData,
    bag,
    periodInfo,
    equipments,
    importersAndManufacturers,
    sectionsVisible,
    noDealAccepted,
    hasNoPortalReport,
    setNoDealAccepted,
    urlParams,
    disabled,
    loading,
    onPeriodChange,
  } = props;
  const { res } = useContext(AvisContext);

  return (
    <div className="blank-media-professional-user-application">
      <CommonData
        applicationData={applicationData}
        bag={bag}
        periodInfo={periodInfo}
        sectionsVisible={sectionsVisible}
        firstLoad={bag.values === null}
        loading={loading}
        title={res("blankMedia_Application_Title_P")}
        textToDisplay="portal_TDN_ProfesionalReportForm"
        urlParams={urlParams}
        disabled={disabled || hasNoPortalReport}
        onPeriodChange={onPeriodChange}
      >
        {!hasNoPortalReport && (
          <NoDealCheckbox
            bag={bag}
            loading={loading}
            textToDisplayKey="portal_TDN_ProfesionalReport_DealNotOccuredPortal"
            sectionsVisible={sectionsVisible}
            noDealAccepted={noDealAccepted}
            setNoDealAccepted={setNoDealAccepted}
            disabled={disabled || loading}
          />
        )}
      </CommonData>
      {hasNoPortalReport && <NotPortalReportMessage />}
      {sectionsVisible && !hasNoPortalReport && (
        <ApplicationSections
          bag={bag}
          disabled={disabled}
          equipments={equipments}
          importersAndManufacturers={importersAndManufacturers}
          loading={loading}
        />
      )}
    </div>
  );
}
